import React, { useState } from 'react';
import { DERSLER } from '../../lib/dersler.js';
import { dengeliIstek, dengeliUygula, profilOranlari } from './yardimcilar';

// DENGELİ SEÇİM (Basım Faz 3, 2026-10-09): sabit olmayan dersleri sunucu seçer (POST /basim/dengeli-secim):
// ders adedi ÖÇ'lere eşit dağılır, zorluk profile göre (Karışık → %30/%40/%30), harf payı ≤ %30, ders
// başına istenen kadar bağlam çifti. Sonuç sabit liste olur → Faz 2 düzenleyicisiyle değiştirilebilir.
// Sınıf, puan aralığı, müfredat ve alıcı ekrandaki seçimlerden; elle sabitlenen derslere dokunulmaz.
export default function DengeliSecim({ apiUrl, konuTest, mufredat, dersler, tumSabitNolar, yayineviId, onUygula }) {
  const [cift, setCift] = useState(0);
  const [tohum, setTohum] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);   // { rapor, testler, uyarilar } | { hata }

  const { istek, matematikGeometri, kazanimYokSayildi } = dengeliIstek(dersler);
  const ad = (k) => (DERSLER.find((x) => x.value === k)?.label || k).replace(/^(TYT|AYT)\s+/i, '');

  const sec = async (yeniTohum) => {
    if (!istek.length) return;
    setYukleniyor(true); setSonuc(null);
    // Yeniden seçilen derslerin eski numaraları dışlanmaz (aynı ders yeniden kurulur); öbür sabitler dışlanır.
    const yeniden = new Set(dersler.filter((d) => d.dengeli && istek.some((i) => i.ders === d.dengeli))
      .flatMap((d) => d.sabitNolar || []));
    const govde = {
      sinav: konuTest.sinav, dersler: istek, cift: Number(cift), tohum: yeniTohum,
      oranlar: profilOranlari(konuTest.zorlukProfil), matematikGeometri,
      haric: (tumSabitNolar || []).filter((n) => !yeniden.has(n)),
    };
    if ([9, 10, 11, 12].includes(Number(konuTest.sinif))) govde.sinif = Number(konuTest.sinif);
    if (mufredat) govde.mufredat = mufredat;
    if (konuTest.puanMin !== '' && konuTest.puanMin != null) govde.puanMin = Number(konuTest.puanMin);
    if (konuTest.puanMax !== '' && konuTest.puanMax != null) govde.puanMax = Number(konuTest.puanMax);
    if (yayineviId != null) govde.yayineviId = yayineviId;
    try {
      const token = localStorage.getItem('yks_token');
      const r = await fetch(`${apiUrl}/api/boru-hatti/basim/dengeli-secim`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify(govde),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.basarili) throw new Error(j.hata || `HTTP ${r.status}`);
      setTohum(yeniTohum);
      onUygula(dengeliUygula(dersler, istek, j));
      setSonuc({ rapor: j.rapor || [], testler: j.testler || [], uyarilar: j.uyarilar || [] });
    } catch (e) {
      setSonuc({ hata: e.message || 'Seçim yapılamadı' });
    }
    setYukleniyor(false);
  };

  return (
    <div data-dengeli className="rounded-lg border border-violet-200 bg-violet-50/40 px-3 py-2 space-y-1.5">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-[10px] text-gray-500 font-bold uppercase"
          title="Ders adedi öğrenme çıktılarına eşit dağılır; zorluk seçili profile göre (Karışık: kolay %30 · orta %40 · zor %30); her harf ders ve testte en çok %30">
          Dengeli seçim
        </span>
        <select data-dengeli-cift value={cift} onChange={(e) => setCift(Number(e.target.value))}
          className="px-1.5 py-1 rounded border border-gray-300 text-[11px]" title="Ders başına bağlam temelli çift (her çift 2 soru, ders adedinin içinde)">
          {[0, 1, 2, 3].map((n) => <option key={n} value={n}>{n ? `ders başına ${n} bağlam çifti` : 'bağlam çifti yok'}</option>)}
        </select>
        <button type="button" data-dengeli-sec disabled={yukleniyor || !istek.length} onClick={() => sec(0)}
          className="text-xs px-3 py-1 rounded-lg bg-violet-600 text-white font-semibold hover:bg-violet-700 disabled:opacity-40">
          {yukleniyor ? '⏳ Seçiliyor…' : '⚖ Dengeli seç'}
        </button>
        {sonuc && !sonuc.hata && (
          <button type="button" data-dengeli-yeniden disabled={yukleniyor} onClick={() => sec(tohum + 1)}
            className="text-xs px-2 py-1 rounded-lg bg-white border border-violet-300 text-violet-800 font-semibold disabled:opacity-40">
            ↻ Farklı sorular
          </button>
        )}
        <span className="text-[10px] text-gray-500">
          {istek.length ? `${istek.map((i) => `${ad(i.ders)} ${i.adet}`).join(' · ')}` : 'Seçilecek ders yok (hepsi elle sabitlenmiş).'}
          {Number(konuTest.sinif) ? ` · ${konuTest.sinif}. sınıf ÖÇ'leri` : ' · sınıf seçilmedi (bütün sınıflar)'}
        </span>
      </div>
      {kazanimYokSayildi && <div className="text-[10px] text-amber-800">Seçili kazanımlar yok sayılır: dengeli seçim dersin bütün öğrenme çıktılarına eşit dağıtır.</div>}
      {sonuc && sonuc.hata && <div data-dengeli-hata className="text-[11px] text-red-700 font-semibold">{sonuc.hata}</div>}
      {sonuc && !sonuc.hata && (
        <div data-dengeli-rapor className="text-[10px] text-gray-700 space-y-0.5">
          {sonuc.rapor.map((r) => (
            <div key={r.ders}>
              <strong>{ad(r.ders)}</strong> {r.secilen}/{r.istenen} · ÖÇ {r.oc_kullanilan}/{r.oc_havuzda}
              {' · '}kolay {r.kova.kolay} · orta {r.kova.orta} · zor {r.kova.zor}{r.cift ? ` · ${r.cift} çift` : ''}
            </div>
          ))}
          {sonuc.uyarilar.map((u) => <div key={u} data-dengeli-uyari className="text-amber-800">⚠ {u}</div>)}
        </div>
      )}
    </div>
  );
}
